import { Grid } from '@mui/material';
import { map, size } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import CustomCard2 from '../../components/cards/CustomCard2';
import PromotionsSidebar from '../../components/sidebars/PromotionsSidebar';
import PromotionWidget from '../../components/widgets/PromotionWidget';
import PageLayout from '../layouts/PageLayout';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';
import CountBadge from '../../components/CountBadge';

// !############### MAIN FUNC ####################
const Promotions = () => {
    const promotions = useSelector((state) => state.promotions.promotions);

    return (
        <>
            <PageLayout
                sidebar={<PromotionsSidebar />}
                head="Promotions managements"
            >
                <CustomCard2
                    title={`CAICA Promotions`}
                    heightClear={640}
                    action={
                        <CountBadge
                            total={size(promotions)}
                            item={'Promotions'}
                        />
                    }
                >
                    <Grid container padding={2} spacing={4}>
                        {size(promotions) > 0 ? (
                            map(
                                promotions,
                                ({
                                    promotion_image,
                                    promotion_name,
                                    status,
                                    id,
                                }) => (
                                    <Grid item sm={4} key={id}>
                                        <PromotionWidget
                                            promotion_name={promotion_name}
                                            promotion_image={promotion_image}
                                            status={status}
                                            id={id}
                                        />
                                    </Grid>
                                ),
                            )
                        ) : (
                            <NoDataFeedback message="No promotion found" />
                        )}
                    </Grid>
                </CustomCard2>
            </PageLayout>
        </>
    );
};

export default Promotions;
